import React from 'react';
import {useNavigate} from "react-router-dom";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {FaArrowRight} from "react-icons/fa";
import {FaRegTrashCan} from "react-icons/fa6";
import {IoMapOutline} from "react-icons/io5";
const SelectArea = () => {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [vendorAreas, setVendorAreas] = React.useState([]);
    const [states, setStates] = React.useState([]);
    const [stateId, setStateId] = React.useState(0);
    const [cities, setCities] = React.useState([]);
    const [cityID, setCityId] = React.useState(0);
    const [areas, setAreas] = React.useState([]);
    const [areaId, setAreaId] = React.useState(-1);



    React.useEffect(() => {
        API.getStates()
            .then((response) => {
                setStates(response.data);
                setIsLoaded(true)

            })
        API.getVendorAreas(window.localStorage.getItem("vendor"))
            .then((response) => {
                setVendorAreas(response.data[0]);
                setIsLoaded(true)

            })
    }, []);

    const onGetCities = (stateID) => {
        setIsLoaded(false)
        const params = {
            state_id : stateID
        }
        API.getCities(params)
            .then((response) => {
                setCities(response.data);
                setIsLoaded(true)

            })
    }

    const onGetAreas = (stateID) => {
        setIsLoaded(false)
        const params = {
            city_id : stateID
        }
        API.getAreas(params)
            .then((response) => {
                setAreas(response.data);
                setIsLoaded(true)

            })
    }


    const handleDelete = (id) => {
        setIsLoaded(false)
        API.deleteVendorAreas(window.localStorage.getItem("vendor"), id)
            .then((response) => {
                toast.success(response.message)
                API.getVendorAreas(window.localStorage.getItem("vendor"))
                    .then((response) => {
                        setVendorAreas(response.data[0]);
                        setIsLoaded(true)

                    })
            })
    }

    const onAddArea = () => {
        if (areaId < 0) {
            toast.error('لطفا منطقه مورد نظر را انتخاب کنید')
            return false
        }
        setIsLoaded(false)
        const request = {
            city: cityID,
            area: areaId
        }

        API.addVendorAreas(window.localStorage.getItem("vendor"),request)
            .then((response) => {
                toast.success(response.message)
                API.getVendorAreas(window.localStorage.getItem("vendor"))
                    .then((response) => {
                        setVendorAreas(response.data[0]);
                        setIsLoaded(true)

                    })
            })
            .catch((error) => {
                setIsLoaded(true)
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);

                }

            });
    }
    return (
        <section className='container rtl pt-3'>
<Toast />
            {
                !isLoaded && <Loading/>
            }
            <div className="row">
                <div className="col-12 mb-4">
                   <span onClick={()=> {
                       window.history.back()
                   }}>
                        <FaArrowRight className='mx-2' />
                    بازگشت
                   </span>

                </div>
                <div className="col-md-4 mt-4  ">
                    <div className="form-floating">
                        <select className="form-select" id="floatingSelect"
                                aria-label="Floating label select example"
                                onChange={(event) => {
                                    setStateId(event.target.value)
                                    onGetCities(event.target.value)
                                }}
                                value={stateId}

                        >
                            <option selected value={0}>انتخاب استان</option>
                            {
                                isLoaded && states.map(group => {
                                        return (
                                            <option value={group.id} key={group.id}>
                                                {group.name}
                                            </option>
                                        );
                                    }
                                )
                            }

                        </select>
                        <label htmlFor="floatingSelect" className="right-0">

                        </label>
                    </div>
                </div>


                <div className="col-md-4 mt-3 ">
                    <div className="form-floating">
                        <select className="form-select" id="floatingSelect"
                                aria-label="Floating label select example"
                                onChange={(event) => {
                                    setCityId(event.target.value)
                                    onGetAreas(event.target.value)
                                }}
                                value={cityID}

                        >
                            <option selected value={0}>انتخاب شهر</option>
                            {
                                isLoaded && cities.map(group => {
                                        return (
                                            <option value={group.id} key={group.id}>
                                                {group.name}
                                            </option>
                                        );
                                    }
                                )
                            }

                        </select>
                        <label htmlFor="floatingSelect" className="right-0">

                        </label>
                    </div>
                </div>


                <div className="col-md-4 mt-3 ">
                    <div className="form-floating">
                        <select className="form-select" id="floatingSelect"
                                aria-label="Floating label select example"
                                onChange={(event) => {
                                    setAreaId(event.target.value)

                                }}
                                value={areaId}
                        >
                            <option selected value={-1}>انتخاب منطقه شهری</option>
                            <option selected value={0}>
                                همه مناطق
                            </option>
                            {
                                isLoaded && areas.map(group => {
                                        return (
                                            <option value={group.id} key={group.id}>
                                                {group.name}
                                            </option>
                                        );
                                    }
                                )
                            }

                        </select>
                        <label htmlFor="floatingSelect" className="right-0">

                        </label>
                    </div>
                </div>

                <div className="col-md-8 mt-3">
                    &nbsp;
                </div>
                <div className="col-md-4 mt-3">
                    <button className='btn btn-primary w-100'
                    onClick={onAddArea}
                    >
                        افزودن
                    </button>
                </div>

            </div>

            <div className="row mt-5 ">
                <div className="col-12 fw-bold text-muted">
                    <IoMapOutline className='mx-2' />
                    لیست مناطق اضافه شده
                </div>
                <div className="col-12">

                    <table className="table table-striped table-bordered mt-3">
                        <thead className="table-light text-center">
                        <tr>
                            <th scope="col">ردیف</th>
                            <th scope="col">شهر</th>
                            <th scope="col">منطقه</th>
                            <th scope="col">عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {vendorAreas && vendorAreas.length > 0 ? (
                            vendorAreas.map((item, index) => (
                                <tr key={item.id} className="align-middle text-center">
                                    <td>{index + 1}</td>
                                    <td>{item.city}</td>
                                    <td>{item.area}</td>
                                    <td>
                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => handleDelete(item.id)}
                                            title="حذف"
                                        >
                                            <FaRegTrashCan />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center text-secondary">
هنوز منطقه ای اضافه نکرده اید و در تمامی شهرها و مناطق امکان خرید از شما وجود دارد
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>

                </div>
            </div>
        </section>
    );
};

export default SelectArea;